<template>
  <div>
    <Alert class="mb-4">
      Lorsqu’une vente est effectuée via prélèvement SEPA (RIB) et que le prélèvement échoue — par exemple en cas de
      refus bancaire, de compte clos ou de fonds insuffisants — la vente est automatiquement annulée et le contrat
      n’apparaît pas sur votre espace. Le client reçoit immédiatement un email lui permettant de réessayer son paiement.
    </Alert>
    <LeadsList status="payment_intent_failed" :noDataMsg="$t('NoLeadFailed')" />
  </div>
</template>

<script>
import { Alert } from "@estaly/ui";
import LeadsList from "@/components/leads/LeadsList.vue";

export default {
  components: {
    Alert,
    LeadsList,
  },
};
</script>
